<template>
  <div>
    <top-header :type="6" :placeholder="'VR体验'" :hasBorder="true" :bgColor="'#fff'" fontSize="0.32rem" />
    <iframe :src="iframeSrc" scrolling="auto" frameborder="0" id="iframe"></iframe>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  name: 'VR',
  data() {
    return {
      iframeSrc: this.$route.query.htmlUrl
    };
  },
  components: {
    topHeader
  },
  mounted() {
  },

  methods: {


  },

}
</script>
<style lang="less" scoped>
#iframe {
  width: 100%;
  height: calc(100vh - 0.9rem);
}
</style>